
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/suositukset",
      function () {
        return require("private-next-pages/suositukset.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/suositukset"])
      });
    }
  